<template>
    <div class="flex flex-row items-center justify-between" >
        <span v-show="!editing">{{ displayName }}</span>
        <input
            v-show="editing"
            type="text"
            :value="displayName"
            class="focus:outline-none"
            ref="subNameInput"
            @blur="(e) => {editing = false; $emit('edited', e.target.value)}"
        >
        <div class="flex flex-row items-center justify-start">
            <div
                class="z-10 opacity-0 text-gray-400 hover:text-gray-800 transition duration-100 ease-in-out group-hover:opacity-100"
                @click="handleEdit"
            >
                <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"></path></svg>
            </div>
            <div
                v-if="deletable"
                class="z-10 opacity-0 text-gray-400 hover:text-gray-800 transition duration-100 ease-in-out group-hover:opacity-100"
                @click="$emit('remove-sub-item', {index: index, subIndex: subIndex})"
            >
                <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path></svg>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "MenuSubItem",
    props: {
        child: {
            type: Object,
            required: true,
        },
        index: {
            type: Number,
            required: true,
        },
        subIndex: {
            type: Number,
            required: true,
        },
        deletable:{
            type: Boolean,
            default: true
        },
        name: String
    },
    data(){
        return {
            editing: false,
        }
    },
    methods: {
        handleEdit: function(){
            this.editing = true
            this.$nextTick(() => {
                this.$refs.subNameInput.focus()
            })
        }
    },
    computed: {
        displayName(){
            return this.name || this.child.name
        }
    }
}
</script>
